// src/app/shared/single-data-picker/single-data-picker.module.ts
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { SingleDataPickerComponent } from "./single-data-picker.component";

@NgModule({
  declarations: [SingleDataPickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule.forRoot(), // Initialize datepicker globally
  ],
  exports: [SingleDataPickerComponent], // Export component for reuse
})
export class SingleDataPickerModule {}
